import { Directive, ViewContainerRef } from "@angular/core"

@Directive({
    selector: "[appAddHost]",
})
export class AddDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
